module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-kommunikation-4ed08720bda299d3dc19ef2db3d4f5ff.svg";